import React from 'react';
import {useLocation} from "react-router-dom";
import {useAdminRoutes, useHelpAndLegalRoutes, useProjectRoutes} from "../../Routing.jsx";
import {useTranslation} from "react-i18next";
import SidebarLinkStandalone from "./links/SidebarLinkStandalone.jsx";
import SidebarLinkGroup from "./links/SidebarLinkGroup.jsx";


function convertRoutes(
    routes,
    pathname,
    setSidebarExpanded,
) {
    let groupedRoutes = [];

    for (let route of routes) {
        let group = route['group'] ?? null;

        route['is_current'] = (pathname === route['path']);

        if (group === null) {
            route['is_group'] = false;
            groupedRoutes[route['name'] + route['path']] = route;
        } else {
            let groupData = groupedRoutes[group];
            if (groupData === undefined) {
                groupData = {
                    is_group: true,
                    is_current: route['is_current'],
                    name: group,
                    icon: route.icon,
                    routes: []
                };
            }

            groupData.routes.push(route);
            groupData['is_current'] = groupData['is_current'] || route['is_current'];
            groupedRoutes[group] = groupData;
        }
    }

    let linksAndGroups = [];

    for (let routeOrGroupKey in groupedRoutes) {
        let routeOrGroup = groupedRoutes[routeOrGroupKey];
        if (routeOrGroup['is_group']) {
            linksAndGroups.push(
                <SidebarLinkGroup
                    key={routeOrGroup['name'] + routeOrGroup['path']}
                    group={routeOrGroup}
                    setSidebarExpanded={setSidebarExpanded}
                />
            );
        } else {
            linksAndGroups.push(
                <SidebarLinkStandalone
                    key={routeOrGroup['name'] + routeOrGroup['path']}
                    route={routeOrGroup}
                    setSidebarExpanded={setSidebarExpanded}
                />
            );
        }
    }

    return linksAndGroups;
}

export default function SidebarLinks({setSidebarExpanded}) {

    const location = useLocation();
    const {pathname} = location;

    let {t} = useTranslation();

    let [projectRoutes, lastProjectName] = useProjectRoutes(true);
    let projectLinks = convertRoutes(projectRoutes, pathname, setSidebarExpanded);

    let [helpAndLegalRoutes] = useHelpAndLegalRoutes();
    let helpAndLegalLinks = convertRoutes(helpAndLegalRoutes, pathname, setSidebarExpanded);

    let [administrationRoutes] = useAdminRoutes();
    let adminLinks = convertRoutes(administrationRoutes, pathname, setSidebarExpanded);

    // noinspection com.intellij.reactbuddy.ArrayToJSXMapInspection
    return (
        <div className="space-y-8 d-none">
            <div>
                <h3 className="group-title text-xs uppercase text-gray-400 dark:text-gray-500 font-semibold pl-3">
                    <span className="lg:hidden lg:sidebar-expanded:block 2xl:block">
                        {lastProjectName}
                    </span>
                </h3>

                <ul className="sidebar-links mt-3">
                    {projectLinks}
                </ul>
            </div>

            {helpAndLegalLinks.length > 0 &&
                <div>
                    <h3 className="group-title text-xs uppercase text-gray-400 dark:text-gray-500 font-semibold pl-3">
                        <span className="lg:hidden lg:sidebar-expanded:block 2xl:block">
                            {t('route.support')}
                        </span>
                    </h3>

                    <ul className="sidebar-links mt-3">
                        {helpAndLegalLinks}
                    </ul>
                </div>
            }

            {adminLinks.length > 0 &&
                <div>
                    <h3 className="group-title text-xs uppercase text-gray-400 dark:text-gray-500 font-semibold pl-3">
                        <span className="lg:hidden lg:sidebar-expanded:block 2xl:block">
                            {t('route.administration')}
                        </span>
                    </h3>

                    <ul className="sidebar-links mt-3">
                        {adminLinks}
                    </ul>
                </div>
            }
        </div>
    );
}
